import React, { useEffect } from "react";
import {
  Container,
  Backdrop,
  CircularProgress,
  Toolbar,
  Typography,
} from "@mui/material";
import { Scrollbars } from "react-custom-scrollbars-4";
import queryString from "query-string";
import FeatureForm from "./FeatureForm";
import ConfirmDelete from "./ConfirmDelete";
import { useSnackbar } from "notistack";
// import { deleteFeature } from "../helpers/deleteFeature";
import { uploadToStorage } from "../helpers/uploadToStorage";
import { db } from "./../firebase";
import { doc, setDoc, collection } from "firebase/firestore";
import { getSchema } from "../helpers/schemas/getSchema";
import { firestoreAutoId } from "../helpers/firestoreAutoId";
import { checkInvalidField } from "../helpers/checkInvalidField";
import { getFormInvalid } from "../helpers/getFormInvalid";
import { applyEditTrackingFields } from "../helpers/applyEditTrackingFields";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { castDateFields } from "../helpers/castDateFields";
import { castDateToFireStoreDate } from "../helpers/castDateToFireStoreDate";
import { onDeleteProject } from "../helpers/onDeleteProject";

function Feature({ user, loading, currentProject }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const [feature, setFeature] = React.useState(null);
  const [schema, setschema] = React.useState([]);
  // const [constraints, setconstraints] = React.useState([]);
  // const [pic_schema, setpic_schema] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);const [isReady, setIsReady] = React.useState(false);
  // const [alertMessage, setalertMessage] = React.useState(null);
  const [formdisabled, setformdisabled] = React.useState(true);
  const [formErrorMessage, setformErrorMessage] = React.useState("");
  const [tablename, settablename] = React.useState("");
  const [id, setid] = React.useState(null);
  // const [ModalisOpen, setModalisOpen] = React.useState(false);
  const [ShowConfirmDelete, setShowConfirmDelete] = React.useState(false);
  // const [ModalTitle, setModalTitle] = React.useState(null);
  // const [ModalMessage, setModalMessage] = React.useState(null);
  const [pics, setpics] = React.useState([]);
  const { passProject } = location.state || {}; // Destructure and provide a default empty object

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        var queryParams = queryString.parse(window.location.search);
        console.log(queryParams);
        setpics([]);
        if (
          "id" in queryParams &&
          "formdisabled" in queryParams &&
          "tablename" in queryParams &&
          "fk_id" in queryParams
        ) {
          await getFeature(
            queryParams["id"],
            queryParams["formdisabled"].toLowerCase() === "true",
            queryParams["tablename"],
            queryParams["fk_id"],
            queryParams,
          );
        } else {
          throw new Error("All required parameters weren't found.");
        }
      } catch (err) {
        enqueueSnackbar(err.message, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };
    
    if (isLoading === true && isReady === false) {
      setIsReady(true);
      fetchData();
    }
  }); 

  const getFeature = async (id, formdisabled, tablename, fk_id, params) => {
    var schema = await getSchema(tablename);
    // const constraints = [];

    var feature = {};

    //  const id = params.id;
    if (id === "new") {
      console.log("Handling new ID");

      schema.forEach((field) => {
        if (field.name === "id") {
          feature[field.name] = id;
        } else if (
          (field["readOnly"] !== null && field.name === "present") ||
          (field["readOnly"] !== null && field.name === "Created By") ||
          (field["readOnly"] !== null && field.name === "Modified By")
        ) {
          feature[field.name] = user.displayName;
        } else if (
          (field["readOnly"] !== null && field.name === "Creator Email") ||
          (field["readOnly"] !== null && field.name === "Modified By Email")
        ) {
          feature[field.name] = user.email;
        } else if (field.type === "datetime") {
          feature[field.name] = new Date();
        } else if (field.type === "bit") {
          feature[field.name] = false;
        } else if (field.name === "deleted") {
          feature[field.name] = 0;
        } else if (field.name === "uid") {
          feature[field.name] = user.uid;
        } else if (Object.hasOwn(params, field.name)) {
          feature[field.name] = params[field.name];
        } else {
          feature[field.name] =
            params[field.name] !== null && params[field.name] !== undefined
              ? params[field.name]
              : "";
        }
      });

      feature = applyEditTrackingFields(feature, user);
    } else {
      feature = passProject ? passProject : {};
    }

    if (
      Object.hasOwn(params, "Site") &&
      params.Site.toLowerCase().includes("sub") &&
      feature.hasOwnProperty("Substation")
    ) {
      feature.Substation = true;
    }

    console.log("Feature object:", feature);

    setFeature(feature);
    setschema(schema);
    // setconstraints(constraints);
    settablename(tablename);
    setformdisabled(formdisabled);
    setid(id);
    setIsLoading(false);
    console.log(feature);
  };

  const edit = () => {
    navigate(
      "/feature?id=" + id + "&formdisabled=false&tablename=" + tablename,
    );
  };

  const confirmDelete = async () => {
    try {
      setShowConfirmDelete(false);
      await onDeleteProject(currentProject, user);
      navigate("/");
    } catch (err) {
      enqueueSnackbar(err.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const cancelDelete = () => {
    console.log("cancelDelete");
    setShowConfirmDelete(false);
  };

  const deleteFeat = () => {
    console.log("delete");
    setShowConfirmDelete(true);
  };

  const save = async () => {
    try {
      setIsLoading(true);

      //check for invalid
      var invalidResults = getFormInvalid(feature, schema);
      if (invalidResults.isInvalid === true) {
        setFeature({ ...invalidResults.feature });
        setschema(invalidResults.schema);
        setformErrorMessage(
          invalidResults.formErrorMessage === "Missing required field: Map"
            ? "Missing required field: Project Address"
            : invalidResults.formErrorMessage,
        );
        setIsLoading(false);
        return;
      }

      var isNew = feature.id === "new";
      if (isNew) {
        feature.id = firestoreAutoId();

        const fp = await uploadToStorage(
          `users/${user.uid}/projects/${feature.id}/attachments/header.png`,
          feature["map"],
        );
        feature["map"] = fp;
        feature["ChecklistTemplates"] = [];
        feature["Checklists"] = [];
        feature["Comments"] = [];
        feature["Contacts"] = [];
        feature["Equipment"] = [];
        feature["ExportTemplates"] = [];
        feature["Files"] = [];
        feature["Issues"] = [];
        feature["Observations"] = [];
        feature["allowed_emails"] = [];
        feature["issues_log"] = [];
        feature["projectStore_ids"] = [];

        const newFeat = castDateFields(feature, schema);
        const newEditFeature = castDateToFireStoreDate({ ...newFeat });
        const docRef = doc(collection(db, "projects"), newEditFeature.id);
        await setDoc(docRef, newEditFeature);
        // const docRef = await addDoc(collection(db, "projects"), feature);
        navigate(`/project/${newEditFeature.id}/dashboard`, {
          state: { passProject: newEditFeature },
        });
      } else {
        const newFeat = castDateFields(feature, schema);
        const newEditFeature = castDateToFireStoreDate({ ...newFeat });
        await setDoc(doc(db, "projects", newEditFeature.id), newEditFeature, {
          merge: true,
        });
        navigate(`/project/${newEditFeature.id}/dashboard}`, {
          state: { passProject: newEditFeature },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const cancel = () => {
    navigate(-1);
  };

  const onMapChange = (value) => {
    console.log(value);
    if (
      feature["map"] !== value &&
      value !== null &&
      value !== undefined &&
      value !== ""
    ) {
      feature["map"] = value;
      setFeature({ ...feature });
    }
  };

  const onAddressChange = (value) => {
    feature["Address"] = value ? value.description : "";
    feature["placeId"] = value ? value.placeId : "";
    console.log(value);
    setFeature({ ...feature });
  };

  const onDateTimePickerChange = (date, field) => {
    feature[field] = date;
    setFeature({ ...feature });
    if (
      feature.hasOwnProperty("arrival") &&
      feature.hasOwnProperty("departure") &&
      feature["arrival"] > feature["departure"]
    ) {
      setformErrorMessage("Arrival must be less than or equal to Departure.");
    } else if (
      feature.hasOwnProperty("arrival") &&
      feature.hasOwnProperty("departure") &&
      feature["arrival"] <= feature["departure"]
    ) {
      setformErrorMessage("");
    }
  };

  const onFormatClick = async (e, id) => {
    e.preventDefault();
    console.log(id);
    var currentString = feature[id];
    if (e.currentTarget.innerText === "Bold") {
      var selText = window.getSelection().toString();
      if (selText.length > 0) {
        var i = currentString.indexOf(selText);
        currentString = [
          currentString.slice(0, i),
          "|",
          currentString.slice(i),
        ].join("");
        currentString = [
          currentString.slice(0, i + selText.length + 1),
          "|",
          currentString.slice(i + selText.length + 1),
        ].join("");
        feature[id] = currentString;

        setFeature({ ...feature });
      }
    } else if (e.currentTarget.innerText === "Italic") {
      var sel_Text = window.getSelection().toString();
      if (sel_Text.length > 0) {
        var x = currentString.indexOf(sel_Text);
        currentString = [
          currentString.slice(0, x),
          "`",
          currentString.slice(x),
        ].join("");
        currentString = [
          currentString.slice(0, x + sel_Text.length + 1),
          "`",
          currentString.slice(x + sel_Text.length + 1),
        ].join("");
        feature[id] = currentString;
        setFeature({ ...feature });
      }
    }
  };

  const onChange = async (e) => {
    try {
      // console.log(e);
      var att = schema.find((item) => item.name === e.target.name);
      //clearout erro message field
      const formErrorMessage = checkInvalidField(e.target.value, att);
      //format dates
      //  if (att.type === "date") {
      //   if (e.target.value.length > 0) {
      //     var date = new Date(e.target.value);
      //     // date.setDate(date.getDate() + 1);
      //     editFeature[e.target.name] = date.toISOString().split("T")[0];
      //     // editFeature[e.target.name] = date.getTime();
      //     setEditFeature({ ...editFeature });
      //     setformErrorMessage(formErrorMessage);
      //   }
      // }
      if (att.type === "date") {
        if (e.target.value.length > 0) {
          var date = new Date(e.target.value);
          // date.setDate(date.getDate() + 1);
          feature[e.target.name] = date.toISOString().split("T")[0];
          // feature[e.target.name] = date.getTime();
          setFeature({ ...feature });
          setformErrorMessage(formErrorMessage);
        }
      } else if (att.type === "bit") {
        feature[e.target.name] = e.target.checked;
        setFeature({ ...feature });
        setformErrorMessage(formErrorMessage);
      } else {
        feature[e.target.name] = e.target.value;
        setFeature({ ...feature });
        setformErrorMessage(formErrorMessage);
      }
    } catch (err) {
      enqueueSnackbar(err.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
    }
  };

  return isLoading ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <Scrollbars
      autoHide
      autoHideTimeout={10}
      style={{ width: "100%", height: "100%" }}
    >
      <Toolbar />
      <Container>
        <Typography
          color="primary.light"
          style={{ paddingTop: 40 }}
          variant="h5"
          gutterBottom
        >
          {formdisabled === false && id === "new"
            ? "New " +
              (tablename.slice(-1) === "s"
                ? tablename
                    .replace(/_/g, " ")
                    .replace(/\w\S*/g, (w) =>
                      w.replace(/^\w/, (c) => c.toUpperCase()),
                    )
                    .substring(0, tablename.length - 1) //this removes the "s" from the end
                : tablename
                    .replace(/_/g, " ")
                    .replace(/\w\S*/g, (w) =>
                      w.replace(/^\w/, (c) => c.toUpperCase()),
                    ))
            : formdisabled === false && id !== "new"
              ? "Edit " +
                tablename
                  .replace(/_/g, " ")
                  .replace(/\w\S*/g, (w) =>
                    w.replace(/^\w/, (c) => c.toUpperCase()),
                  )
              : tablename
                  .replace(/_/g, " ")
                  .replace(/\w\S*/g, (w) =>
                    w.replace(/^\w/, (c) => c.toUpperCase()),
                  )}
        </Typography>

        <FeatureForm
          className="higher"
          feature={feature}
          schema={schema}
          onChange={onChange}
          // onFocus={onFocus}
          // currentFocus={currentFocus}
          onFormatClick={onFormatClick}
          onDateTimePickerChange={onDateTimePickerChange}
          onAddressChange={onAddressChange}
          onMapChange={onMapChange}
          edit={edit}
          save={save}
          cancel={cancel}
          delete_feature={deleteFeat}
          formdisabled={formdisabled}
          formErrorMessage={formErrorMessage}
          pics={pics}
          // getAcceptedFiles={getAcceptedFiles}
          // onPicCommentChange={onPicCommentChange}
          isLoading={isLoading}
          showPics={
            tablename === "issue" ||
            tablename === "issue_comment" ||
            tablename === "observation" ||
            tablename === "observation_comment"
              ? true
              : false
          }
        />

        <br />
        <ConfirmDelete
          ShowConfirmDelete={ShowConfirmDelete}
          cancelDelete={cancelDelete}
          confirmDelete={confirmDelete}
        />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    </Scrollbars>
  );
}

export default Feature;
